module.exports = __webpack_public_path__ + "static/desktop/img/design-mobile-diarybook.98e00ddb.png";